$dependencyManager.addDependencyCallback('gsap', () => {
  class Hotspots {
    constructor(imageContainer, data) {
      this.imageContainer = imageContainer;
      this.data = data;
      this.buttonContainer = null;
      this.isPulsating = true; // Flag to control pulsation

      this.init();
    }

    init() {
      const buttonContainer = jQuery('<div class="mad-hotspots-button-container"></div>');
      this.imageContainer.append(buttonContainer);
      this.buttonContainer = buttonContainer;
      this.addButtons();
    }

    addButtons() {
      this.data.forEach(hotspot => {
        const button = jQuery('<div></div>', {
          text: hotspot.label,
          class: 'mad-hotspot-button',
          css: {
            top: hotspot.position.y,
            left: hotspot.position.x,
            opacity: 0
          },
          click: () => {
            hotspot.clickCallback();

            // Stop pulsation for 10 seconds
            this.isPulsating = false;
            clearTimeout(this.pulsationTimeout);
            this.pulsationTimeout = setTimeout(() => {
              this.isPulsating = true;
              this.scheduleNextPulsation();
            }, 30000);
          }
        });

        this.buttonContainer.append(button);

        // Animate the button appearance with zoom-in effect using GSAP
        gsap.to(button, {
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          clearProps: 'transform'
        });
      });

      this.scheduleNextPulsation();
    }

    scheduleNextPulsation() {
      const randomTime = this.getRandomTime(5000, 10000);
      this.pulsationTimeout = setTimeout(() => {
        if (this.isPulsating) {
          // Select a random button
          const randomIndex = Math.floor(Math.random() * this.data.length);
          const button = this.buttonContainer.children('.mad-hotspot-button').eq(randomIndex);

          // Pulsate the selected button
          this.pulsateButton(button);
        }

        // Schedule the next pulsation
        this.scheduleNextPulsation();
      }, randomTime);
    }

    pulsateButton(button) {
      // Pulsate animation using GSAP
      gsap.fromTo(button, {
        scale: 1
      }, {
        scale: 1.6,
        duration: 0.6,
        yoyo: true,
        repeat: 1,
        clearProps: 'transform' // Clear transform property after animation
      });
    }

    getRandomTime(min, max) {
      return Math.random() * (max - min) + min;
    }
  }

  window.Hotspots = Hotspots;
  jQuery(document).trigger('madHotspotsInitialized');
  
}, true);
